export default __webpack_public_path__ + "static/media/Aboutbg3.eb8663b5.png";